<template>
  <div style="display: flex;flex: 1;height: calc(100vh - 63px);padding-bottom: 40px;">

 
  <el-table
    :data="dataList"
    size="mini"
    empty-text="暂无数据"
    :height="tabHeight"
    @row-contextmenu="rowContextmenu"
    style="width: 100%">
    <el-table-column
      label="移动目录"
      align="center"
      width="70">
      <template slot-scope="scope">
        <el-button type="text" size="small" class="drag-edit">
          <i class="drag-edit" title="可拖拽放置指定的目录中"><svg-drag :width="18" :height="18" fill="#606266"></svg-drag></i>
        </el-button>
      </template>
    </el-table-column>
    <el-table-column
      label="序号"
      align="center"
      width="50px"
      type="index">
    </el-table-column>
    <el-table-column label="企业logo" width="80px">
      <template slot-scope="scope">
        <comp-icon
          :src="scope.row.CompLogo"
          :width="40"
          :height="40"
        ></comp-icon>
      </template>
    </el-table-column>
    <el-table-column label="企业名称" prop="CompName">
      <template slot-scope="scope">
        <span style="font-size: 14px;">{{ scope.row.CompName }}</span>
      </template>
    </el-table-column>
    <el-table-column label="备注" prop="Remark">
      <template slot-scope="scope">
        <div class="text-clamp2" :title="scope.row.Remark">{{ scope.row.Remark }}</div>
      </template>
    </el-table-column>
    <el-table-column
      label="操作"
      width="150"
      align="center">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="goDetail(scope.row)">查看</el-button>
        <el-button type="text" size="small" @click="edit(scope.row)" v-if="isCanEdit">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row)" v-if="isCanEdit">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
   </div>
</template>

<script>
import { OpenService } from '@/service'

import CompIcon from "@/components/icon/comp-icon.vue";
import SvgDrag from '@/components/svg/drag.vue';

export default {
  props: {
    dataList: { default: [] },
    isCanEdit: { default: true }
  },
  data() {
    return {
      tabHeight: document.body.clientHeight - 20 - 43 - 40
    }
  },
  mounted() {
    window.onresize = () => {
      this.tabHeight = document.body.clientHeight - 20 - 43 - 40
    }
  },
  components: { CompIcon, SvgDrag },
  methods: {
    goDetail(row) {
      OpenService.openCompDetail(row.CompID);
    },
    edit(row) {
      this.$emit('remarkEdit', row);
    },
    del(row) {
      this.$emit('del', row);
    },
    rowContextmenu(row, column, event) {
      this.$emit('rowContextmenu', row, event);
    }
  }
}
</script>

